import { createTransform } from 'redux-persist';

import { IInventoriesState } from '../../types/inventories';

const inventoriesItemsTransforms = createTransform(
  // Annotated so the inferred shape keeps `items` nullable: without it the `items: null` literal
  // narrows the transform's type parameter to `null` and the outbound state no longer matches.
  (stateIn: IInventoriesState): IInventoriesState => {
    return {
      ...stateIn,
      items: null,
      csvUpload: {
        file: null,
        result: null,
        isLoading: false,
      },
    };
  },
  (stateOut: IInventoriesState) => stateOut,
  { whitelist: ['inventories'] },
);

const inventoryMetaDataTransforms = createTransform(
  (stateIn: IInventoriesState) => stateIn,
  (stateOut: IInventoriesState) => {
    return {
      ...stateOut,
      error: null,
      isLoading: false,
      isInventoryItemLoading: false,
      isLowInventoryLoading: false,
      isInventoryReportLoading: false,
    };
  },
  { whitelist: ['inventories'] },
);

const transformArray = [inventoriesItemsTransforms, inventoryMetaDataTransforms];

export default transformArray;
